import { isDesktop } from "../utilities/screenSize";
import Slider from "../utilities/Helpers/UI/Slider";

LUC.jsCollaborationReferences = {
    alpine: true,
    screenSize: "",
    sliderConfig: {
        slidesPerView: 1.3,
        spaceBetween: 20,
        enabled: true,
        centeredSlides: false,
        pagination: false,
        createElements: true,
    },

    init() {
        this.screenSize = isDesktop() ? "desktop" : "mobile";
        this.renderFeatureImages();
        window.scrollTo({ top: 0, behavior: "smooth" });
    },

    createBaseContainer() {
        return this.createContainer("tw-bg-neutrals-90", "tw-w-full");
    },

    createSliderContainer() {
        return this.createContainer("section", "collaboration__featured-images", "swiper");
    },

    createContainer(...classes) {
        const container = document.createElement("div");
        container.classList.add(...classes);

        return container;
    },

    createImageSlide(imageUrl) {
        const slide = this.createContainer("swiper-slide", "tw-flex", "tw-justify-center", "tw-items-center");
        const image = document.createElement("img");
        image.src = imageUrl;
        image.loading = "lazy";
        image.classList.add("!tw-max-w-full", "tw-h-auto", "tw-block");
        slide.appendChild(image);

        return slide;
    },

    createCtaButton(simpleTextEl) {
        const btn = document.createElement("a");
        btn.classList.add("collaboration__btn-fimages");

        if (simpleTextEl.dataset.jsCtaLabel.length > 0) {
            btn.href = simpleTextEl.dataset.jsCtaUrl;
            btn.innerText = simpleTextEl.dataset.jsCtaLabel;
        } else {
            btn.href = simpleTextEl.dataset.jsSimpleText;
            btn.innerText = "Show collection";
        }

        return btn;
    },

    initializeSlider(container) {
        return new Slider(container, this.sliderConfig);
    },

    renderFeatureImages() {
        const collaborationReference = this.$refs.collaborate;
        const featuredImages = collaborationReference.querySelectorAll("[data-js-collab-featured-image]");
        const simpleTextEl = collaborationReference.querySelector("[data-js-simple-text]");
        const sliderContainer = this.createSliderContainer();

        const baseContainer = this.createBaseContainer();
        baseContainer.setAttribute("data-js-collab-featured-images", "");
        baseContainer.append(sliderContainer);
        simpleTextEl.parentNode.insertBefore(baseContainer, simpleTextEl.nextSibling);
        // Create and add slides
        featuredImages.forEach((fImage) => {
            const slide = this.createImageSlide(fImage.dataset.jsCollabFeaturedImage);
            sliderContainer.append(slide);
        });
        if (this.screenSize === "mobile") {
            this.initializeSlider(sliderContainer);
        }

        // Add CTA button
        const btn = this.createCtaButton(simpleTextEl);

        sliderContainer.parentNode.insertBefore(btn, sliderContainer.nextSibling);
    },
};
